<mat-form-field appearance="outline" class="full-width" [subscriptSizing]="'dynamic'">
  <mat-label>{{ 'epd.functions.careplan.row-table.title' | translate | capitalize }}</mat-label>
  <mat-select [value]="selectedId()" (selectionChange)="versionChange.emit($event.value)">
    @if (showNewOption()) {
      <mat-option [value]="newVersion">
        {{ 'general.words.new' | translate | capitalize }}
      </mat-option>
    }
    @for (registration of registrations(); track registration.id) {
      <mat-option [value]="registration.id">
        {{
          'epd.functions.careplan.row-table.select-option'
            | translate
              : {
                  STATE:
                    registration.state === conceptState
                      ? ('general.words.concept' | translate | capitalize)
                      : ('general.words.final' | translate | capitalize),
                  DATE: registration.viewRegisteredDate || registration.registeredOn | date: 'dd-MM-yyyy',
                  TIME: registration.viewRegisteredDate || registration.registeredOn | date: 'HH:mm',
                  USER: registration.viewRegisteredUser
                    ? registration.viewRegisteredUser
                    : registration.registeredBy
                      ? registration.registeredBy.firstname + ' ' + registration.registeredBy.lastname
                      : '',
                }
            | capitalize
        }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
